module.exports = __webpack_public_path__ + "static/media/logo2.f1014bbd.jpg";